import { FaUser, FaUserShield, FaUserCog, FaCode } from "react-icons/fa";
import { Badge } from "react-bootstrap";

export const getRoleBadge = (role) => {
    const roleMap = {
        superadmin: { color: "danger", label: "Super Admin", icon: <FaUserShield /> },
        admin: { color: "primary", label: "Admin", icon: <FaUserCog /> },
        supervisor: { color: "info", label: "Supervisor", icon: <FaUser /> },
        editor: { color: "warning", label: "Editor", icon: <FaUser /> },
        viewer: { color: "secondary", label: "Viewer", icon: <FaUser /> },
        user: { color: "dark", label: "User", icon: <FaUser /> },
        developer: { color: "success", label: "Developer", icon: <FaCode /> },
    };

    const roleInfo = roleMap[role] || roleMap.user;

    return (
        <Badge
            bg={roleInfo.color}
            className="d-flex align-items-center gap-1 rounded-pill py-1 px-2 shadow-sm"
        >
            {roleInfo.icon} {roleInfo.label}
        </Badge>
    );
};
